<style scoped>
.close {
  cursor: pointer;
  color: #dc3545;
  position: absolute;
  top: 0;
  right: 1rem;
  z-index: 99;
}
.property-card {
  cursor: pointer;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.line-h19 {
  line-height: 19px;
}

.line-h38 {
  line-height: 38px;
}
</style>

<template>
  <div>
    <b-row>
      <b-col>
        <search-property-form
          id="search-form"
          :selected-apn-list="selectedApns"
          @properties-found="propertiesFound"
          @property-clicked="toggleProperty"
        />
        <div v-if="hasSelectedProperties">
          <div class="text-large line-h19">Selected Properties:</div>
          <div class="text-small line-h19">*Search again to add multiple properties to this loan
            request. Your Main Property will be in a dark background.</div>
        </div>
        <div v-else class="text-large line-h38">
          You have not selected any property for this deal yet.
        </div>
      </b-col>
    </b-row>
    <hr v-if="hasSelectedProperties">
    <transition-group name="fade">
      <b-row
        v-for="property in selected"
        :key="`${property.apn}-${property.address}`"
        class="mb-3"
      >
        <b-col>
          <div>
            <font-awesome-icon
              size="lg"
              @click="removeProperty(property)"
              class="close mr-2 mt-2"
              icon="times"
            />
            <b-card
            no-body
            v-b-tooltip.hover
            v-b-tooltip.title="
            isMainProperty(property) ?
            'This is your Main Property' :
            'Select as Main Property'
            "
            :bg-variant="isMainProperty(property) ? 'dark' : 'light'"
            :text-variant="isMainProperty(property) ? 'light' : 'dark'"
            class="pointer-cursor"
            @click="setMainProperty(property)"
            >
            <cross-display
            :cross="property"
            />
          </b-card>
          </div>
        </b-col>
      </b-row>
    </transition-group>
    <b-row v-if="error">
      <b-col>
        <div class="errors col-md-12">{{ error }}</div>
      </b-col>
    </b-row>
    <search-property-modal
      id="search-modal"
      :properties="properties"
      :selected-apn-list="selectedApns"
      :has-selected-properties="hasSelectedProperties"
      @properties-found="propertiesFound"
      @property-clicked="toggleProperty"
    />
  </div>
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import SearchPropertyModal from '@/components/utils/properties/SearchPropertyModal';
import CrossDisplay from '@/components/utils/properties/CrossDisplay';
import SearchPropertyForm from '@/components/utils/properties/SearchPropertyForm';


library.add(faTimes);


export default {
  components: {
    SearchPropertyForm,
    SearchPropertyModal,
    CrossDisplay,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    buttonVariant: {
      type: String,
    },
  },
  data() {
    return {
      properties: [],
      selected: {},
      error: null,
    };
  },
  computed: {
    hasSelectedProperties() {
      return (
        (this.form.address && this.form.address.apn !== undefined) ||
        (this.form.crosses && this.form.crosses.length > 0)
      );
    },
    mainApn() {
      return this.form.address ? this.form.address.apn : null;
    },
    selectedApns() {
      return Object.keys(this.selected);
    },
  },
  watch: {
    mainApn(newVal) {
      if (newVal && newVal.length > 1) {
        this.setCrosses();
      } else {
        this.crosses = [];
      }

      this.validate();
    },
    selectedApns(newVal) {
      if (newVal.length === 0) {
        this.$set(this.form, 'address', null);
        this.form.crosses = [];
      } else {
        this.setCrosses();
      }
    },
  },
  methods: {
    validate() {
      let errorNewValue = null;
      if (!(this.form.address && this.form.address.apn)) {
        if (this.properties && this.properties.length > 0) {
          errorNewValue = 'Please, select at least one property to continue!';
        } else {
          errorNewValue = 'Press Search button to display legal APN and Address!';
        }
      }

      this.error = errorNewValue;

      return this.error === null;
    },
    setCrosses() {
      const apns = this.selectedApns;
      if (this.mainApn) {
        const crosses = [];
        apns.forEach((apn) => {
          if (apn !== this.mainApn) {
            crosses.push(this.selected[apn]);
          }
        });

        this.form.crosses = crosses;
      } else {
        this.setMainProperty(this.selected[apns[0]]);
      }
    },
    setMainProperty(property) {
      if (this.mainApn === property.apn) {
        this.form.address = null;
      } else {
        this.form.address = property;
      }
    },
    isMainProperty(property) {
      return this.mainApn === property.apn;
    },
    selectProperty(property) {
      this.$set(this.selected, property.apn, property);
    },
    removeProperty(property) {
      if (this.isMainProperty(property)) {
        this.form.address = null;
      }

      this.$delete(this.selected, property.apn);
    },
    toggleProperty(property) {
      if (this.selected[property.apn]) {
        this.removeProperty(property);
      } else {
        this.selectProperty(property);
      }
    },
    propertiesFound(propertyList) {
      this.properties = propertyList;
      if (propertyList.length > 0 && !this.form.crosses) {
        this.form.crosses = [];
        this.error = '';
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/properties/SearchProperties.vue